module.exports = __webpack_public_path__ + "static/media/icon-trash.9426e566.svg";